import React from 'react';
import moment from 'moment';
import { Table, Select } from 'antd';

const cabinDepartments = [
	'232','445','446','447','448','449','450','451','452','1160','1161','1162','1163','1164','1165','1166','1167','1168','1169','1170','1171','1172','1173','1174','1175','1176','1177','1178','1179','1180','1181','1182','1183','1675','1676','1677','1678','1832','1833'
];

export default class TransactionTable extends React.Component {
	state = {
		tz: 'America/Chicago'
	}
	renderDollars = (text, record, index) => {
		if (!text && text !== 0) return;
		text = Math.round(parseFloat(text)*100) / 100;
		return <div style={{textAlign:'right'}}>${text.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
	}
	render() {
		let columns = [
			{title: 'Date', dataIndex: 'Date',
				render: (text, record, index) => {
					if (text) return <span title={text}>{moment.utc(text).tz(this.state.tz).format('YYYY-MM-DD HH:mm')}</span>
				}
			},
			{title: 'Description', dataIndex: 'BaseMessage',
				render: (text, record, index) => {
					if (record.DepartmentId !== null && cabinDepartments.indexOf(record.DepartmentId) !== -1) text = text.split('Cabin')[0]+'Cabin';
					return <span>{text.split(' [USD]').join('')}</span>
				}
			},
			{title: 'Name', dataIndex: 'Name'},
			{title: 'Charge', dataIndex: 'Charge', render: this.renderDollars},
			{title: 'Payment', dataIndex: 'Payment', render: this.renderDollars}
		];
		let i = 0;
		return (
			<div>
				{this.props.variant === 'admin' &&
					<div style={{textAlign:'right'}}>
						Display times in timezone:&nbsp;
						<Select style={{width:'50%'}} value={this.state.tz} onChange={(value) => this.setState({ tz: value })}>
							{moment.tz.names().map(zone => <Select.Option key={zone} value={zone}>{zone}</Select.Option>)}
						</Select>
					</div>
				}
				<Table
					bordered
					size="small"
					style={{backgroundColor:'white'}}
					rowKey="index"
					dataSource={this.props.transactions.concat([
						{BaseMessage: 'Total', Charge: this.props.chargeTotal, Payment: this.props.creditTotal, id: 'total'},
						{BaseMessage: this.props.dueText || 'Due', Payment: this.props.chargeTotal - this.props.creditTotal, id: 'owed'}
					]).map(row => { row.index = i++; return row; })}
					columns={(this.props.noNames)? columns.filter(column => column.title !== 'Name'): columns}
					pagination={false} />
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./portal-components/TransactionTable/index.jsx